import axios from 'axios';

import {
  CLIENT_SIGNUP_SAVE,
  CLIENT_SIGNUP_SAVE_SUCCESS,
  CLIENT_SIGNUP_SAVE_FAIL,
  GENERAL_REQUEST_LOADING,
  GENERAL_REQUEST_LOADED,
  CLIENT_SIGNUP_RESUME,
  CLIENT_SIGNUP_RESUME_SUCCESS,
  CLIENT_SIGNUP_RESUME_FAIL,
  CLIENT_UPDATE_APPLICATION,

  MODAL_FORM_RESET,
  SNACKBAR_SET,

  PROCESS_APPLICATION,
  PROCESS_APPLICATION_START,
  PROCESS_APPLICATION_SUCCESS,
  PROCESS_APPLICATION_FAIL,
  
  SIGNUP_APPLICATION_STRIPE_LOADING,
  SIGNUP_APPLICATION_STRIPE_FAILED,
  SIGNUP_APPLICATION_STRIPE_ACTION_REQUIRED,

  UPDATE_APPLICATION_DATA,
  PARTNER_INSURANCE_SUCCESS,
  PARTNER_INSURANCE_FAIL,
  PARTNER_INSURANCE,
  INVALIDATE_APPLICATION,
} from './types';
import history from '../utility/common/History.js';

const { REACT_APP_API_URL } = process.env;

/*------------------------ ObiSignup ----------------------*/
export const updateApplicationData = (fieldName, fieldValue) => {
  return {
    type: UPDATE_APPLICATION_DATA,
    fieldName: fieldName,
    fieldValue: fieldValue
  };
};

export const updateApplication = (fieldData) => {
  return (dispatch) => {
    dispatch({
      type: CLIENT_UPDATE_APPLICATION,
      fieldData: fieldData
    });
  };
}

export const paymentStripeAwaitLoading = () => {
  return {
    type: SIGNUP_APPLICATION_STRIPE_LOADING,
  };
}

export const paymentStripeAwaitFailed = (error) => {
  return {
    type: SIGNUP_APPLICATION_STRIPE_FAILED,
    error: error
  };
}

export const invalidateApplication = () => {
  return {
    type: INVALIDATE_APPLICATION,
  };
}

export const getPartnerInsurance = (partnerID) => {
  return (dispatch) => {
    dispatch({ type: PARTNER_INSURANCE });
    dispatch({ type: GENERAL_REQUEST_LOADING });
    
    const data = {partnerID: partnerID};
    const endpoint = '/partner/insurance/get';
    const successAction = PARTNER_INSURANCE_SUCCESS;
    const failAction = PARTNER_INSURANCE_FAIL;
    const showSnackbar = {error: true, success: false}
    const redirects = {error: false, success:false}
    signupAPI(dispatch, data, endpoint, successAction, failAction, showSnackbar, redirects);
    
  };
};

export const paymentClientSignup = (applicationID, StripeToken, StripeEmail, applicationState) => {
  return (dispatch) => {
    dispatch({ type: PROCESS_APPLICATION });
    dispatch({ type: PROCESS_APPLICATION_START});
    dispatch({ type: GENERAL_REQUEST_LOADING });
    
    const data = {...applicationState, applicationID: applicationID, stripeToken: StripeToken, stripeEmail: StripeEmail};
    const endpoint = '/client/signup/payment';
    const successAction = PROCESS_APPLICATION_SUCCESS;
    const failAction = PROCESS_APPLICATION_FAIL;
    const showSnackbar = {error: true, success: false}
    const redirects = {error: false, success:'/signup/thanks/'+ applicationID}
    // Delegate to signupAPI which returns a promise; it will suppress redirects when requires_action is present
    return signupAPI(dispatch, data, endpoint, successAction, failAction, showSnackbar, redirects);
    
  };
};

export const saveClientSignup = (applicationState, applicationID, partnerID, hubspotID, proceedToReview=false) => {
  return (dispatch) => {
    dispatch({ type: CLIENT_SIGNUP_SAVE });
    dispatch({ type: GENERAL_REQUEST_LOADING });
    
    const data = {...applicationState, applicationID: applicationID, partnerID: partnerID, hubspotID: hubspotID};
    const endpoint = '/client/signup/save';
    const successAction = CLIENT_SIGNUP_SAVE_SUCCESS;
    const failAction = CLIENT_SIGNUP_SAVE_FAIL;
    const showSnackbar = {error: false, success: false}
    const redirects = {error: false, success: (proceedToReview)? '/signup/review/:appid': ''}
    signupAPI(dispatch, data, endpoint, successAction, failAction, showSnackbar, redirects);
    
  };
};

export const resumeClientSignup = (applicationID) => {
  return (dispatch) => {
    dispatch({ type: CLIENT_SIGNUP_RESUME });
    dispatch({ type: GENERAL_REQUEST_LOADING });
    
    const data = {applicationID: applicationID};
    const endpoint = '/client/signup/resume';
    const successAction = CLIENT_SIGNUP_RESUME_SUCCESS;
    const failAction = CLIENT_SIGNUP_RESUME_FAIL;
    const showSnackbar = {error: false, success: false}
    signupAPI(dispatch, data, endpoint, successAction, failAction, showSnackbar);
    
  };
};

const signupAPI = (dispatch, data, endpoint, successAction, failAction=CLIENT_SIGNUP_SAVE_FAIL, showSnackbar={success:true}, redirects={error: false, success: false}) => {
  const signupChangeSuccess = (
    dispatch,
    data,
    successType,
    showSnackbar
  ) => {
    dispatch({
      type: MODAL_FORM_RESET,
    });
    dispatch({ type: GENERAL_REQUEST_LOADED });
    if(showSnackbar && showSnackbar.success){
      dispatch({
        type: SNACKBAR_SET,
        message: data.message,
        severity: 'notificationBarSuccess',
        horizontal: 'center',
        vertical: 'bottom',
      });
    }
    dispatch({
      type: successType,
      data,
    });

    if(redirects.success && redirects.success !== false){
      let urlParts = String(redirects.success).split(':');
      const url = urlParts[0] + ((urlParts.length > 1)? data[urlParts[1]] : '');
      history.push(url);
    }
  };
  
  const signupChangeFail = (dispatch, failAction, error, errors, showSnackbar) => {
    dispatch({ type: GENERAL_REQUEST_LOADED });
    dispatch({
      type: failAction,
      error,
      errors
    });
    if(showSnackbar && showSnackbar.error){
      dispatch({
        type: SNACKBAR_SET,
        message: errors.message,
        severity: 'notificationBarFailed',
        horizontal: 'center',
        vertical: 'bottom',
      });
    }
    if(redirects.error && redirects.error !== false){
      const url = redirects.error;
      history.push(url);
    }
  };

  return axios.post(`${REACT_APP_API_URL}${endpoint}`, {
    data: data,
  })
  .then((response) => {
    if (response.data.code === 0) {
      if (response.data.data && response.data.data.status === 'requires_action') {
        dispatch({ type: GENERAL_REQUEST_LOADED });
        dispatch({ type: SIGNUP_APPLICATION_STRIPE_ACTION_REQUIRED });
        return response.data.data;
      }
      signupChangeSuccess(
        dispatch,
        response.data.data,
        successAction,
        showSnackbar
      );
    } else {
      signupChangeFail(
        dispatch,
        failAction,
        true,
        response.data.data.error,
        showSnackbar
      );
    }
    return response.data.data;
  })
  .catch((error) => {
    signupChangeFail(
      dispatch,
      failAction,
      true,
      { message: 'Error communicating with Olympia Benefits server. Try or contacting Olympia Benefits.'},
      showSnackbar
    );
    return Promise.reject(error);
  });

  
}
